import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import * as AuthActions from 'app/store/actions/auth.actions';
import * as StoreActions from 'app/store/actions/resetStore.actions';
import { Store } from "@ngrx/store";
import { AppState } from "../app.reducer";
import { PersistanceService } from "app/services/persistance.service";


@Injectable()
export class AuthEffects {

    constructor(
        private actions$: Actions,
        private store: Store<AppState>,
        private persistenceSvc: PersistanceService
    ) {
    }

    setUser$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(AuthActions.SET_AUTHENTICATED),
            switchMap((action: AuthActions.SetAuthenticated) => {
                this.persistenceSvc.setUser(action.usuarioAutenticado);
                return of(this.persistenceSvc.setUser(action.usuarioAutenticado))
            })
        );
    },
        { dispatch: false });


    unSetUser$ = createEffect((): any => {

        return this.actions$.pipe(
            ofType(AuthActions.UNSET_AUTHENTICATED),
            switchMap(() => {
                console.log("EFECTO DE UNSET_AUTHENTICATED")
                this.store.dispatch(new StoreActions.ResetStore());
                return of(this.persistenceSvc.removeUser());

            })
        )

    },
        { dispatch: false }
    );


}

